import { getRgObjectsOfType as u, RG_TYPE as f } from "@project-rouge/rg-core";
import { getLevelCount as w } from "../../object-helpers/index3.js";
import { getNIA as y } from "./index38.js";
const B = (m) => {
  let r = 0;
  const g = 75, t = 2, h = 4246, p = 0.95, M = 2.04, q = 1.5, b = 0.6, F = 1.603, V = 2 * g, A = 0.035 * Math.pow(F, 3 / 2) * Math.sqrt(30), C = u(m, f.Building);
  for (const s of C) {
    const o = w(s, !1), T = y(s) / o, l = u(s, f.Module).length / o, a = T / (l * t), _ = o * M + p, d = o * q + b, i = o * h * (9.81 / 1e3), x = (_ + d) * a + i / t, E = (1.35 * _ + 1.5 * d) * a + 1.35 * i / t, N = x / V, n = 0.05, c = Math.ceil(Math.sqrt(N) / n) * n;
    let e = Math.max(0.25, c / 4);
    const R = E / 2 / (c * 1e3 * A);
    e = Math.max(e, Math.ceil(R / n) * n);
    const v = c * c * e;
    r += v * l * t;
  }
  return r;
};
export {
  B as getFoundationConcreteVolume
};
//# sourceMappingURL=index22.js.map
